/**
 * RestoreIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const RestoreIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M10.863 2.363a.9.9 0 0 1 1.274 1.274L10.674 5.1H12a8.4 8.4 0 1 1-7.465 4.547l.046-.08a.9.9 0 0 1 1.553.907l-.166.344A6.6 6.6 0 1 0 12 6.9h-1.326l1.463 1.463.061.069a.9.9 0 0 1-1.266 1.266l-.069-.061-3-3a.89.89 0 0 1-.137-1.097 1 1 0 0 1 .137-.177z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const RestoreIcon = makeIcon('RestoreIcon', RestoreIconSvg)
